// gamblingaggregators.js
import { getPolConfig } from "./polAggregators";

export function getGamblingColours() {
  // Same Tableau-style distinct palette you’re using elsewhere
  const DISTINCT = [
    "#4e79a7",
    "#f28e2b",
    "#e15759",
    "#76b7b2",
    "#59a14f",
    "#edc948",
    "#b07aa1",
    "#ff9da7",
    "#9c755f",
    "#bab0ab",
  ];
  return DISTINCT;
}

export function getGamblingConfig() {
  const groupsById = {
    // --- Gambling in last year ---
    bh_gambling_last_year: {
      type: "likert",
      label: "Gambling in the last year",
      fulltext: "Have you participated in any form of gambling at all during the past 12 months?",
      keys: [
        "model_BH_gambling_last_year_1_pred",
        "model_BH_gambling_last_year_2_pred",
        "model_BH_gambling_last_year_3_pred",
      ],
      labels: {
        model_BH_gambling_last_year_1_pred: "Yes",
        model_BH_gambling_last_year_2_pred: "No",
        model_BH_gambling_last_year_3_pred: "Not sure",
      },
      colors: {
        model_BH_gambling_last_year_1_pred: "#59a14f",
        model_BH_gambling_last_year_2_pred: "#e15759",
        model_BH_gambling_last_year_3_pred: "#bab0ab",
      },
      polarity: {
        pos: "model_BH_gambling_last_year_1_pred",
        neg: "model_BH_gambling_last_year_2_pred",
        neu: "model_BH_gambling_last_year_3_pred",
      },
      schema:"single",
    },

    bh_support_legal_sports_betting: {
      type: "likert",
      label: "Support legal sports betting",
      fulltext: "Overall, do you support or oppose the legalization of sports gambling in your state?",
      keys: [
        "model_BH_support_legal_sports_betting_1_pred",
        "model_BH_support_legal_sports_betting_2_pred",
        "model_BH_support_legal_sports_betting_3_pred",
        "model_BH_support_legal_sports_betting_4_pred",
        "model_BH_support_legal_sports_betting_5_pred",
      ],
      labels: {
        model_BH_support_legal_sports_betting_1_pred: "Strongly support",
        model_BH_support_legal_sports_betting_2_pred: "Somewhat support",
        model_BH_support_legal_sports_betting_3_pred: "Somewhat oppose",
        model_BH_support_legal_sports_betting_4_pred: "Strongly oppose",
        model_BH_support_legal_sports_betting_5_pred: "Not sure",
      },
      polarity: {
        pos: [
          "model_BH_support_legal_sports_betting_1_pred",
          "model_BH_support_legal_sports_betting_2_pred",
        ],
        neu: "model_BH_support_legal_sports_betting_3_pred",
        neg: [
          "model_BH_support_legal_sports_betting_4_pred",
          "model_BH_support_legal_sports_betting_5_pred",
        ],
      },
      colors: {
        model_BH_support_legal_sports_betting_1_pred: "#2E7D32", 
        model_BH_support_legal_sports_betting_2_pred: "#8cd17d",
        model_BH_support_legal_sports_betting_3_pred: "#f9a099",
        model_BH_support_legal_sports_betting_4_pred: "#C62828", 
        model_BH_support_legal_sports_betting_5_pred:  "#bab0ab",
 
      },
      schema:"single",
    },

    // --- Where should betting taxes be spent ---
    bh_betting_taxes_spend: {
      type: "categorical",
      label: "How betting taxes should be spent",
      fulltext: "How should tax revenue from sports betting be spent?",
      keys: [
        "model_BH_betting_taxes_spend_public_schools_pred",
        "model_BH_betting_taxes_spend_public_health_pred",
        "model_BH_betting_taxes_spend_public_works_pred",
        "model_BH_betting_taxes_spend_policing_pred",
        "model_BH_betting_taxes_spend_fire_rescue_pred",
        "model_BH_betting_taxes_spend_disaster_pred",
        "model_BH_betting_taxes_spend_environment_pred",
        "model_BH_betting_taxes_spend_other_pred",
        "model_BH_betting_taxes_spend_not_sure_pred",
      ],
      labels: {
        model_BH_betting_taxes_spend_public_schools_pred: "Public schools",
        model_BH_betting_taxes_spend_public_health_pred: "Hospitals or Public Health",
        model_BH_betting_taxes_spend_public_works_pred: "Public works / infrastructure",
        model_BH_betting_taxes_spend_policing_pred: "Policing",
        model_BH_betting_taxes_spend_fire_rescue_pred: "Fire and rescue",
        model_BH_betting_taxes_spend_disaster_pred: "Disaster relief",
        model_BH_betting_taxes_spend_environment_pred: "Environment",
        model_BH_betting_taxes_spend_other_pred: "Other",
        model_BH_betting_taxes_spend_not_sure_pred: "Not sure",
      },
      // default distinct palette (you can override if you want specific assignments)
      colors: {
        model_BH_betting_taxes_spend_public_schools_pred: "#4e79a7",
        model_BH_betting_taxes_spend_public_health_pred: "#f28e2b",
        model_BH_betting_taxes_spend_public_works_pred: "#e15759",
        model_BH_betting_taxes_spend_policing_pred: "#76b7b2",
        model_BH_betting_taxes_spend_fire_rescue_pred: "#59a14f",
        model_BH_betting_taxes_spend_disaster_pred: "#edc948",
        model_BH_betting_taxes_spend_environment_pred: "#b07aa1",
        model_BH_betting_taxes_spend_other_pred: "#9c755f",
        model_BH_betting_taxes_spend_not_sure_pred: "#bab0ab",
      },
      
      schema:"single",
    },

    prediction_markets_regulation: {
      type: "categorical",
      label: "How prediction markets should be regulated",
      fulltext: "Which of the following statements comes closer to your view?",
      keys: [
        "prediction_markets__banned_pred_n",
        "prediction_markets__same_gambling_pred_n",
        "prediction_markets__diff_gambling_pred_n",
        "prediction_markets__no_regulation_pred_n",
        "prediction_markets__dk_pred_n",
      ],
      labels: {
        prediction_markets__banned_pred_n: "Ban entirely",
        prediction_markets__same_gambling_pred_n: "Same as gambling",
        prediction_markets__diff_gambling_pred_n: "Different from gambling",
        prediction_markets__no_regulation_pred_n: "No regulation",
        prediction_markets__dk_pred_n: "Not sure",
      },
      colors: {
        prediction_markets__banned_pred_n: "#C1121F",
        prediction_markets__same_gambling_pred_n: "#F77F00",
        prediction_markets__diff_gambling_pred_n: "#4CC9F0",
        prediction_markets__no_regulation_pred_n: "#06D6A0",
        prediction_markets__dk_pred_n: "#94a3b8",
      }, 
      polarity: {
        pos: "prediction_markets__no_regulation_pred_n",
        neg: "prediction_markets__banned_pred_n",
        neu: ["prediction_markets__same_gambling_pred_n", "prediction_markets__diff_gambling_pred_n", "prediction_markets__dk_pred_n"],
      },
      schema: "tracking",
      waves: [3,4],
    },

    // ── Wave-4 tracking additions (July 2026) ─────────────────────────────

    // The SURVEY question is multi-select ("select all that apply"), but the
    // MODELLED columns are not: the seven shares sum to 1.0 on every row of the
    // wave-4 tracking table (checked at row level: min 0.997, max 1.003, so the
    // spread is rounding). They are a mutually exclusive, exhaustive partition
    // of adults, i.e. a recode of the multi-select into one category per person.
    // Consequences: they CAN be stacked and read as shares of the population,
    // and "traded with real money" is a floor for trading rather than the full
    // count of people who have ever traded. Which recode rule produced them
    // (deepest engagement vs first selected) is not recoverable from the data,
    // so copy should not lean on the categories being ordered by involvement.
    pm_done: {
      type: "categorical",
      label: "Prediction market experience",
      fulltext: "Which of the following, if any, have you ever done? Please select all that apply.",
      keys: [
        "model_pm_traded_real_money_pred_n",
        "model_pm_fake_money_preds_pred_n",
        "model_pm_checked_markets_pred_n",
        "model_pm_news_coverage_pred_n",
        "model_pm_discussed_pred_n",
        "model_pm_heard_pred_n",
        "model_pm_not_heard_pred_n",
      ],
      labels: {
        model_pm_traded_real_money_pred_n: "Traded with real money",
        model_pm_fake_money_preds_pred_n: "Used a play-money forecasting site",
        model_pm_checked_markets_pred_n: "Checked odds without trading",
        model_pm_news_coverage_pred_n: "Saw news coverage citing odds",
        model_pm_discussed_pred_n: "Discussed prediction markets",
        model_pm_heard_pred_n: "Have only heard of them",
        model_pm_not_heard_pred_n: "Had not heard of them",
      },
      colors: {
        model_pm_traded_real_money_pred_n: "#C1121F",
        model_pm_fake_money_preds_pred_n: "#F77F00",
        model_pm_checked_markets_pred_n: "#4CC9F0",
        model_pm_news_coverage_pred_n: "#4e79a7",
        model_pm_discussed_pred_n: "#06D6A0",
        model_pm_heard_pred_n: "#b07aa1",
        model_pm_not_heard_pred_n: "#94a3b8",
      },
      schema: "tracking",
      waves: [4],
    },


    pm_regulate: {
      type: "categorical",
      label: "Who should regulate prediction markets",
      fulltext: "Who do you think should be mainly responsible for regulating prediction markets?",
      keys: [
        "model_pm_reg_federal_pred_n",
        "model_pm_reg_state_pred_n",
        "model_pm_reg_both_pred_n",
        "model_pm_reg_unreg_pred_n",
        "model_pm_reg_DK_pred_n",
      ],
      labels: {
        model_pm_reg_federal_pred_n: "A single federal regulator",
        model_pm_reg_state_pred_n: "Individual states",
        model_pm_reg_both_pred_n: "Both, sharing responsibility",
        model_pm_reg_unreg_pred_n: "No one, largely unregulated",
        model_pm_reg_DK_pred_n: "Don't know",
      },
      // Palette chosen for the CHOROPLETH, not for a legend swatch, because this
      // group's map is the point of it. Validated with the dataviz skill's
      // checker under --pairs all (every pair can touch on a map, unlike a
      // stacked bar where only neighbours do).
      //
      // Semantics: federal = blue, state = orange, and "both" = violet, which is
      // literally the blend of the two. "Don't know" is a deliberate neutral.
      //
      // The three that actually co-occur on the map are federal / state / DK,
      // because "both" wins outright in all 436 districts so the top-choice map
      // is one flat colour and the SECOND-choice map is the informative one.
      // That trio passes every gate all-pairs in light and dark (worst pair
      // CVD ΔE 10.1, normal-vision 17.5).
      //
      // Two known validator flags, both accepted deliberately:
      //   - DK trips the chroma floor ("reads gray"). That is the intent: a
      //     neutral for "no opinion" must not look like another position.
      //   - unreg (#1baf7a) sits at 2.74:1 on white, under the 3:1 bar, so it
      //     carries the relief requirement of a visible label. It is the rarest
      //     answer at 3.3% and is never top or second in any district, so it
      //     only ever appears as a labelled legend swatch.
      colors: {
        model_pm_reg_federal_pred_n: "#2a78d6",
        model_pm_reg_state_pred_n: "#eb6834",
        model_pm_reg_both_pred_n: "#4a3aa7",
        model_pm_reg_unreg_pred_n: "#1baf7a",
        model_pm_reg_DK_pred_n: "#78716c",
      },
      schema: "tracking",
      waves: [4],
    },

    econ_approve: { ...getPolConfig().groupsById.econ_approve, hidden: true },
  };

  return { groupsById };
}

/**
 * Builds lookup maps for labels + colors from your groups config
 * (standalone copy, matching your existing pattern)
 */
const DISTINCT = [
  "#4e79a7",
  "#f28e2b",
  "#e15759",
  "#76b7b2",
  "#59a14f",
  "#edc948",
  "#b07aa1",
  "#ff9da7",
  "#9c755f",
  "#bab0ab",
];

export function buildLabelColorMaps(groupsById) {
  const labels = {};
  const colors = {};
  let colorIdx = 0;

  for (const g of Object.values(groupsById)) {
    for (const k of g.keys) {
      labels[k] = (g.labels && g.labels[k]) || k;

      if (!colors[k]) {
        if (g.colors && g.colors[k]) {
          colors[k] = g.colors[k];
        } else if (g.type === "likert") {
          colors[k] = baseColorForLikertKey(g, k);
        } else {
          colors[k] = DISTINCT[colorIdx % DISTINCT.length];
          colorIdx += 1;
        }
      }
    }
  }

  return { labels, colors };
}

/**
 * Weighted aggregation helper (standalone copy, matching your existing pattern)
 */
export function aggregateWeighted(
  rows,
  keys,
  { rowKey, weight = "total", predicate = null } = {}
) {
  const acc = Object.create(null);
  const zero = Object.fromEntries(keys.map((k) => [k, 0]));

  for (const r of rows || []) {
    if (predicate && !predicate(r)) continue;
    const d = r[rowKey];
    if (!d) continue;

    const w = Number(r[weight] ?? 0);
    if (!acc[d]) acc[d] = { w: 0, sums: { ...zero } };

    acc[d].w += w;
    for (const k of keys) acc[d].sums[k] += Number(r[k] ?? 0) * w;
  }

  const out = {};
  for (const [d, { w, sums }] of Object.entries(acc)) {
    const values = {};
    for (const k of keys) values[k] = w > 0 ? (sums[k] / w) * 100 : 0;
    out[d] = { totalWeight: w, values };
  }
  return out;
}

export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  const entry = Object.entries(pol).find(([_, polKey]) => {
    if (Array.isArray(polKey)) return polKey.includes(key);
    return polKey === key;
  });

  const tag = entry?.[0];

  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}

export function getDemoGamblingConfig() {
  const { groupsById } = getGamblingConfig();
  const { bh_support_legal_sports_betting, prediction_markets_regulation } = groupsById;
  return { groupsById: { bh_support_legal_sports_betting, prediction_markets_regulation } };
}

// Tab-as-config default export
export default {
  tab: "gamble",
  label: "Prediction Markets",
  get metrics() { return getGamblingConfig().groupsById; },
};
